import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface CategoriaOcupacaoBarProps {
  ocupacao?: {
    inscritos: number;
    vagas?: number | null;
    filaEspera: number;
    vagasDisponiveis?: number | null;
  } | null;
}

const CategoriaOcupacaoBar: React.FC<CategoriaOcupacaoBarProps> = ({ ocupacao }) => {
  if (!ocupacao) {
    return <span>Não definido</span>;
  }

  const { inscritos, vagas, filaEspera } = ocupacao;

  if (vagas === null || vagas === undefined) {
    return (
      <Typography variant="body2" component="span">
        {`${inscritos} inscritos · ${filaEspera} na fila`}
      </Typography>
    );
  }

  const percentual = Math.min(100, Math.max(0, vagas > 0 ? (inscritos / vagas) * 100 : 100));

  return (
    <Box>
      <LinearProgress
        variant="determinate"
        value={percentual}
        aria-valuenow={percentual}
        aria-label={`Ocupação da categoria: ${inscritos} de ${vagas} inscritos, ${filaEspera} na fila de espera`}
        aria-valuetext={`Ocupação da categoria: ${inscritos} de ${vagas} inscritos, ${filaEspera} na fila de espera`}
      />
      <Typography variant="body2" component="span">
        {`${inscritos}/${vagas} inscritos · ${filaEspera} na fila`}
      </Typography>
    </Box>
  );
};

export default CategoriaOcupacaoBar;
